import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import * as service from 'services/payment.service.ts';
import { Error } from 'components/app/_helpers/app-errors.helper';

const SLICE_ID = 'stripe';

export const buyFc = createAsyncThunk(
  SLICE_ID + '/buyProduct',
  async (payload: { finalCutId: FinalcutId; paymentPlan: number }, { rejectWithValue }) => {
    try {
      const { finalCutId, paymentPlan } = payload;
      const res = await service.createPaymentSession(finalCutId, paymentPlan);
      window.location.href = res.data.url;
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);

export const upgradeResolution = createAsyncThunk(
  SLICE_ID + '/upgradeResolution',
  async (payload: { finalCutId: FinalcutId; paymentPlan: number }, { rejectWithValue }) => {
    try {
      const { finalCutId, paymentPlan } = payload;
      const res = await service.upgradeResolution(finalCutId, paymentPlan);
      if (res.status !== 200) toast.error('Failed to upgrade resolution. Please try again or contact support.');
      else toast.success('Resolution upgraded successfully!');
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);

export const buySubscription = createAsyncThunk(
  SLICE_ID + '/buySubscription',
  async (payload: service.SubscriptionType, { rejectWithValue }) => {
    try {
      const res = await service.createSubscriptionSession(payload);
      window.location.href = res.data.url;
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);

export const updSubscription = createAsyncThunk(
  SLICE_ID + '/updSubscription',
  async (payload: service.SubscriptionType, { rejectWithValue }) => {
    try {
      const res = await service.upgradeSubscription(payload);
      if (res.status !== 200) toast.error('Failed to update subscription. Please try again or contact support.');
      else toast.success('Subscription updated successfully!');
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);

export const cancelSubscription = createAsyncThunk(SLICE_ID + '/cancelSubscription', async (_, { rejectWithValue }) => {
  try {
    await service.cancelAllSubscriptions();
    toast.success('Subscription has been cancelled!');
  } catch (error) {
    return rejectWithValue(Error.reduxErrorHandler(error));
  }
});
